import axios from 'axios'

const state = {
    list: [],
    rates: [],
    load: true,
    dataUploaded: false,
    error: false,
    errorText: '',
};
const mutations = {
    add(state, item) {
        state.list.push(item);
    },
    err(state, text) {
        state.error = true;
        state.errorText = text;
        state.load = false;
        state.dataUploaded = false;
    }
};
const actions = {
    get_rates(context, d) {
        if (d.c1 === d.c2) {
            context.state.rates.push({
                date: d.date,
                c1: d.c1,
                c2: d.c2,
                course: 1,
            });
            if (d.callback) d.callback(context.getters.rate(d.date, d.c1, d.c2));
            return;
        }
        let item = context.getters.rate(d.date, d.c1, d.c2);
        if (item) {
            if (d.callback) d.callback(context.getters.rate(d.date, d.c1, d.c2));
            return;
        }
        context.state.rates.push({
            date: d.date,
            c1: d.c1,
            c2: d.c2,
            course: 0,
        });
        if (d.c1 === d.c2) {
            item.course = 1;
            if (d.callback) d.callback(context.getters.rate(d.date, d.c1, d.c2));
            return;
        }
        axios({
            method: 'get',
            url: '/tourclient/currencyRates?currencyId=' + d.c1 + '&secondCurrencyId=' + d.c2 + '&date.Serialized=' + d.date + '&_=' + new Date().getTime()
        }).then(r => {
            item = context.getters.rate(d.date, d.c1, d.c2);
            if (r.data && r.data.ResultQueryInfo && r.data.ResultQueryInfo.HasError) {
                window.app.$notify.warning({
                    message: r.data.ResultQueryInfo.UserMessages,
                });
                item.course = 1;
                if (d.callback) d.callback(context.getters.rate(d.date, d.c1, d.c2));
                return;
            }
            item.course = r.data.Value ? r.data.Value : 1;
            if (d.callback) d.callback(context.getters.rate(d.date, d.c1, d.c2));
        }).catch(e => {
            item = context.getters.rate(d.date, d.c1, d.c2);
            context.state.rates.splice(context.state.rates.indexOf(item), 1);
            window.app.$notify.warning({
                message: 'Не удалось получить курс',
            });
        });
    },
    get_list(context) {
        if (context.state.dataUploaded) return;
        context.state.load = true;
        context.state.dataUploaded = true;
        axios({
            method: 'post',
            url: '/tourclient/masterAgent/dictionary/currency/list',
            data: {
                request: JSON.stringify({"removeZero": true, "Full": true, "RetrieveMappings": true}),
                removeZero: true,
            }
        }).then(r => {
            if (r.data.ResultQueryInfo.HasError) {
                context.dispatch('error', {status: r.status, text: r.data.ResultQueryInfo.UserMessages}, {root: true});
                return;
            }
            r.data.Items.forEach(item => {
                item.value = item.Id;
                item.label = item.Name;
                context.commit('add', item);
            });
            context.state.load = false;
        }).catch(e => {
            context.dispatch('error', e, {root: true});
        });
    },
    re_list(context) {
        context.state.error = false;
        context.state.errorText = '';
        context.state.load = false;
        context.state.dataUploaded = false;
        context.dispatch('get_list');
    },
};
const getters = {
    national: state => {
        if (!state.list.length) return null;
        return state.list.filter(i => {
            return i.IsNational;
        })[0];
    },
    getById: (state, getters) => id => {
        if (!state.list.length) return null;
        return state.list.filter(i => {
            return i.value === id;
        })[0] || {};
    },
    getIso: (state, getters) => id => {
        if (!state.list.length) return null;
        let a = state.list.filter(i => {
            return i.value === id;
        })[0];
        return a ? a.IsoCode : '';
    },
    getName: (state, getters) => id => {
        if (!state.list.length) return null;
        let a = state.list.filter(i => {
            return i.value === id;
        })[0];
        return a ? a.Name : '';
    },
    rate: (state) => (date, c1, c2) => {
        if (c1 === c2) return {date: date, c1: c1, c2: c2, course: 1};
        return state.rates.filter(i => {
            return date === i.date && c1 === i.c1 && c2 === i.c2;
        })[0];
    },
    load_retes: state => {
        return !!state.rates.filter(i => {
            return !i.course
        })[0];
    }

};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
